'use strict';

(function() {
  window.atex = window.atex || {};

  var contentDefaults = {
      meta: {
        id: null
      },

      data: {
        aspects: {
          'atex.OneCMS': {
            data: {
              '_type': 'atex.OneCMS'
            }
          },

          'p.InsertionInfo': {
            data: {
              '_type': 'p.InsertionInfo'
            }
          }
        }
      },

      local: {
        valid: false,
        conflict: false,
        persisted: false,
        existsOnServer: false
      }
  };

  var contentPrototype = {

  };

  var contentFromBlueprint = function(contentData, contentMetaData, contentLocalData) {
    var content = Object.create(contentPrototype);

    var contentDefaultsCopy = JSON.parse(JSON.stringify(contentDefaults));

    content.meta = _.extend({}, contentDefaultsCopy.meta, contentMetaData);
    content.data = _.extend({}, contentDefaultsCopy.data, contentData);
    content.local = _.extend({}, contentDefaultsCopy.local, contentLocalData);

    return content;
  };

  var contentFromTemplate = function() {
    var content = Object.create(contentPrototype);

    var contentDefaultsCopy = JSON.parse(JSON.stringify(contentDefaults));

    content.meta = _.extend({}, contentDefaultsCopy.meta, { creationDate: new Date() });
    content.data = _.extend({}, contentDefaultsCopy.data);
    content.local = _.extend({}, contentDefaultsCopy.local);

    return content;
  };

  atex.Content = function(contentDataOrTemplateId, contentMetaData, contentLocalData) {
    if (arguments.length === 0) {
      return contentFromTemplate(contentDataOrTemplateId);
    } else {
      return contentFromBlueprint(contentDataOrTemplateId, contentMetaData, contentLocalData);
    }
  };
})();
